export default __webpack_public_path__ + "static/media/hot-10.cbeb1f29.png";